import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import argumentSelectors from '@/redux/selectors/argumentSelectors.js';
import { useSelector } from 'react-redux';

const useNetSuiteChangeAction = ({ dataSource, lookupActionId }) => {
  const isNetsuite = useSelector((state) => argumentSelectors[dataSource].activeApp(state)?.slug === 'netsuite');
  const isUpdateOperation = useArgSelector(argumentSelectors[dataSource].activeAction({ lookupActionId }), lookupActionId)?.operation === 'update';
  const isUpdateAction = useArgSelector(argumentSelectors[dataSource].activeAction({ lookupActionId }), lookupActionId)?.name?.toLowerCase()?.includes('update');
  const isCreateOperation = useArgSelector(argumentSelectors[dataSource].activeAction({ lookupActionId }), lookupActionId)?.operation === 'create';
  const isCreateAction = useArgSelector(argumentSelectors[dataSource].activeAction({ lookupActionId }), lookupActionId)?.name?.toLowerCase()?.includes('create');

  const isUpdate = isUpdateOperation && isUpdateAction;
  const isCreate = isCreateOperation && isCreateAction;

  return {
    isNetsuiteChange: isNetsuite && (isUpdate || isCreate),
    isNetsuiteCreate: isNetsuite && isCreate,
    isNetsuiteUpdate: isNetsuite && isUpdate
  };
};

export default useNetSuiteChangeAction;
